import React, { useEffect, useState } from 'react';
import useApi from 'hooks/useApi';
import StatisticsCard from 'components/dashboards/saas/stats-cards/StatisticsCard';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ObservationRender from 'components/dashboards/monitoring/ObservationRender';
import DateRangeSelector from 'screens/common/components/DateRangeSelector';
import {
  getSmsTemplateCard,
  getSmsTemplateGraph,
  getSmsLastUpdatedDate
} from 'api/endpoints/SmsDashboard';
import { jwtDecode } from 'jwt-decode';
import { get, isEmpty } from 'lodash';
import { getTenantFromToken } from 'utils/routeUtils';

function SmsDashboard() {
  const tenant = getTenantFromToken();
  const getSmsCardApi = useApi(getSmsTemplateCard);
  const getSmsGraphApi = useApi(getSmsTemplateGraph);
  const getSmsDateApi = useApi(getSmsLastUpdatedDate);
  const [cardData, setCardData] = useState({});
  const [graphData, setGrapData] = useState({});
  const [lastupdatedDate, setLastupdatedDate] = useState({});
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedRange, setSelectedRange] = useState({
    value: 'this_month',
    label: 'This Month'
  });

  //API function calling
  useEffect(() => {
    if (startDate && endDate) {
      fetchCardData();
      fetchGraphData();
      fetchLastUpdatedDate();
    }
  }, [startDate, endDate]);

  //Fetching Card Data
  const fetchCardData = async () => {
    try {
      getSmsCardApi.request({
        startDate,
        endDate
      });
    } catch (error) {
      console.error('Error fetching card data:', error);
    }
  };

  //Fetching Graph Data
  const fetchGraphData = async () => {
    try {
      getSmsGraphApi.request({
        startDate,
        endDate
      });
    } catch (error) {
      console.error('Error fetching graph data:', error);
    }
  };

  //Fetching lastupdated Date
  const fetchLastUpdatedDate = async () => {
    try {
      getSmsDateApi.request();
    } catch (error) {
      console.error('Error fetching graph data:', error);
    }
  };

  //Card data value stored
  useEffect(() => {
    const data = get(getSmsCardApi, 'data.results', []);
    setCardData(data);
  }, [getSmsCardApi.data]);

  //Graph data value stored
  useEffect(() => {
    const data = get(getSmsGraphApi, 'data.results', []);
    setGrapData(data);
  }, [getSmsGraphApi.data]);

  //Last updated date stored
  useEffect(() => {
    const data = get(getSmsDateApi, 'data.results', []);
    setLastupdatedDate(data);
  }, [getSmsDateApi.data]);

  //set the formatted startDate and EndDate
  const handleDateChange = (date, field) => {
    let formattedDate = date; // Initialize formattedDate outside the conditional scope

    if (date) {
      const d = new Date(date);
      const day = ('0' + d.getDate()).slice(-2);
      const month = ('0' + (d.getMonth() + 1)).slice(-2); // Month is zero-based
      const year = d.getFullYear();
      formattedDate = `${year}-${month}-${day}`;
    }

    // Now set the appropriate state based on the field parameter
    if (field === 'start_date') {
      setStartDate(formattedDate);
    } else if (field === 'end_date') {
      setEndDate(formattedDate);
    }
  };

  return (
    <div>
      <Row className="g-3 g-lg-4">
        <Col md={6}>
          {/* Use the new DateRangeSelector component */}
          <DateRangeSelector
            selectedRange={selectedRange}
            setSelectedRange={setSelectedRange}
            handleDateChange={handleDateChange}
          />
        </Col>
        <Col md={6} className="text-end">
          <span>
            <strong>Last updated on</strong> {lastupdatedDate?.date}
          </span>
        </Col>
      </Row>

      {/* Cards Section */}
      <Row className="g-3 mt-3">
        {Object.keys(cardData).map((key, index) => {
          const item = cardData[key];
          const stat = {
            value: item.count,
            info: item.description,
            title: item.title,
            suffix: '',
            desc: ''
          };

          const CardContent = (
            <StatisticsCard
              stat={stat}
              style={{ minWidth: '12rem', height: '100%' }}
              index={index}
            />
          );
          return (
            <Col key={index} sm={4} md={4}>
              {item.endpoint ? (
                <Link
                  to={`/${tenant}${item.endpoint}`}
                  style={{ textDecoration: 'none' }}
                >
                  {CardContent}
                </Link>
              ) : (
                CardContent // If card.route is null, render the card without the Link
              )}
            </Col>
          );
        })}
      </Row>

      {/* Chart Section */}
      {!isEmpty(graphData) && (
        <Row className="g-3 mb-5 mt-1">
          <ObservationRender
            key={'graphData'}
            observation={graphData}
            loading={getSmsGraphApi?.loading}
          />
        </Row>
      )}
    </div>
  );
}

export default SmsDashboard;
